import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/other/Loader";
import HeroSection from "../../../../layout/HeroSection";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonESCsBESCEs } from "../../../../redux/action/lessonsAction";
import SecureContent from "../../../../components/secureContent";

const ESCs_BESCs = () => {
  const dispatch = useDispatch();
  const { eSCsBESCEsList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonESCsBESCEs());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
      <SecureContent/>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"ESCs/BESCs"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Electrical engineering and robot combat",
              path: pageRoutes?.lessons?.electricalEngineering,
            },
            { name: "ESCs/BESCs", path: `${pageRoutes?.home}/` },
          ]}
        />
        <Listing contentData={eSCsBESCEsList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default ESCs_BESCs;
